import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import Footer from "components/common/Footer";
import Header from "components/ui/Header2";

const TermsAndConditions = () => {
  const { t } = useTranslation();

  const handlePhoneClick = () => {
    window.open(`tel:07772235662`, "_self");
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Main Content Sections */}
      <div className="w-full max-w-[1182px] mx-auto px-[20px] sm:px-[30px] lg:px-[40px] py-[60px] sm:py-[80px] lg:py-[100px]">
        <div className="flex flex-col gap-[60px] sm:gap-[80px] lg:gap-[100px]">
          {/* Our Story Section */}
          <section className="flex flex-col lg:flex-row gap-[40px] lg:gap-[60px] items-center">
            <div className="lg:w-1/2">
              <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
                {t("من نحن ؟", { defaultValue: "من نحن ؟" })}
              </h2>
              <p className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-medium leading-[20px] sm:leading-[24px] lg:leading-[28px] text-global-text2 mb-[20px] sm:mb-[30px]">
                في رحيق نؤمن أن الطبيعة تحمل أسرار العافية والجمال، لذلك نسعى
                لتقديم أفضل منتجات الأعشاب والزيوت الطبيعية المختارة بعناية
                لتدعم أسلوب حياة صحي ومتوازن. بدأت رحلتنا بشغف حقيقي نحو الطب
                الطبيعي والمنتجات العضوية، وهدفنا أن نجعل الوصول إلى المنتجات
                العشبية الموثوقة أسهل للجميع، بجودة عالية وتجربة شراء مريحة
                وآمنة. نحن نعمل على اختيار المنتجات بعناية، مع التركيز على
                النقاء والجودة، لنقدم لعملائنا تجربة تجمع بين التراث الطبيعي
                والمعايير الحديثة في الخدمة والتوصيل. في رحيق لا نقدم منتجات
                فقط، بل نشارككم أسلوب حياة يعتمد على التوازن، العناية الذاتية،
                والاستفادة من خيرات الطبيعة بطريقة آمنة وموثوقة. ✨ رحيق… قوة
                الطبيعة بين يديك.
              </p>
            </div>
          </section>

          {/* Mission Section */}
          <section className="bg-accent rounded-[20px] p-[30px] sm:p-[40px] lg:p-[50px] text-center">
            <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
              {t("مهمتنا", { defaultValue: "مهمتنا" })}
            </h2>
            <p className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-medium leading-[20px] sm:leading-[24px] lg:leading-[28px] text-global-text2 max-w-[800px] mx-auto">
              نوفر لعملائنا منتجات وخدمات استثنائية تُحسّن حياتهم. نسعى جاهدين
              للتميز في كل ما نقوم به، ونبني مجتمعًا قائمًا على الثقة والابتكار
              والاستدامة.
            </p>
          </section>

          {/* Call to Action Section */}
          <section className="bg-global-text4 rounded-[20px] p-[30px] sm:p-[40px] lg:p-[50px] text-center">
            <h2 className="text-[20px] sm:text-[24px] lg:text-[32px] font-svn-gilroy font-bold leading-[28px] sm:leading-[32px] lg:leading-[40px] text-global-text8 mb-[20px] sm:mb-[30px]">
              انضم إلى رحلتنا
            </h2>
            <p className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-medium leading-[20px] sm:leading-[24px] lg:leading-[28px] text-global-text8 mb-[30px] sm:mb-[40px] max-w-[600px] mx-auto">
              هل أنت مستعد لمعرفة المزيد أو التواصل معنا؟ يسعدنا التواصل معك.
            </p>
            <Button
              variant="primary"
              onClick={handlePhoneClick} // Navigate to contact page
              className="bg-global-text8 text-global-text4 rounded-[8px] px-[20px] sm:px-[30px] lg:px-[40px] py-[10px] sm:py-[15px] lg:py-[20px] text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-bold"
            >
              تواصل معنا
            </Button>
          </section>
        </div>
      </div>

      {/* Include Footer at the bottom */}
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
